<div class="modal-header">
  <h4 class="modal-title">{{ "products.register.missing_fender_serial.title" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
@if (savingComplete) {
  <div class="modal-body" ngbAutofocus>
    <div class="text-center">
      <fa-icon icon="check-circle" style="color: green; font-size: 50px"></fa-icon>
      <br />
      <br />
      {{ "products.register.missing_fender_serial.success_message" | translate }}
      <br />
      <br />
      <button class="btn btn-primary" type="button" (click)="viewGear()">{{ "products.register.missing_fender_serial.view_my_gear" | translate }}</button>
    </div>
  </div>
}
@if (!savingComplete) {
  <div class="modal-body" ngbAutofocus>
    <span [innerHTML]="'products.register.missing_fender_serial.intro_text' | translate"></span>
    <br />
    <div class="form-group m-b-20">
      <label for="serial" class="control-label">{{ "products.register.missing_fender_serial.serial_number" | translate }}</label>
      <input type="text" disabled id="serial" class="form-control" [(ngModel)]="serial" />
      <button class="btn btn-secondary btn-sm m-t-10" type="button" (click)="reEnterSerial()">Re-Enter Serial Number</button>
    </div>
    <div class="form-group m-b-20">
      <label for="sku" class="control-label">{{ "products.register.missing_fender_serial.sku" | translate }}</label>
      <small class="text-muted">{{ "products.register.missing_fender_serial.sku_help" | translate }}</small>
      <div class="d-flex">
        <input class="form-control m-r-5" name="sku" id="sku" [(ngModel)]="sku" (keyup.enter)="searchSku()" />
        <button class="btn btn-primary" type="button" (click)="searchSku()">
          <fa-icon [icon]="searchingSku ? 'spinner' : 'search'" [animation]="searchingSku ? 'spin' : ''"></fa-icon>
        </button>
      </div>
      <div class="m-t-10 m-b-20">
        <small class="pad text-muted bold">{{ "products.register.where_find_sku" | translate }}</small>
        <br />
        <small class="pad text-muted" [innerHTML]="'products.register.where_find_sku_help' | translate"></small>
      </div>
      @if (!foundSku && !unknownSku) {
        <button class="btn btn-secondary btn-sm" type="button" (click)="unknownSku = true">{{ "products.register.missing_fender_serial.unknown_sku" | translate }}</button>
      }
    </div>
    @if (foundSku && !unknownSku) {
      <div class="m-y-30">
        <hr />
        {{ "products.register.missing_fender_serial.found_sku_message" | translate }}
        <br />
        <br />
        <div class="d-flex m-y-20 align-items-center">
          @if (foundSku.product.imageUrl) {
            <img [src]="foundSku.product.imageUrl" class="m-r-20" style="max-width: 200px; max-height: 200px" />
          }
          <div>
            <span class="fui-heading-font t-20">{{ foundSku.product.title }}</span>
            <br />
            <br />
            <button class="btn btn-primary btn-sm" type="button" [disabled]="saving" (click)="submit()">
              {{ "products.register.missing_fender_serial.add_to_account" | translate }}
              @if (saving) {
                <fa-icon icon="spinner" class="m-l-10" [animation]="'spin'"></fa-icon>
              }
            </button>
            <button class="btn btn-blank btn-sm" type="button" [disabled]="saving" (click)="unknownSku = true; foundSku = undefined; sku = ''">
              {{ "products.register.missing_fender_serial.not_my_gear" | translate }}
            </button>
          </div>
        </div>
        <hr />
      </div>
    }
    @if (skuNotFound) {
      <div class="m-y-30">
        <hr />
        {{ "products.register.missing_fender_serial.sku_not_found" | translate }}
        <hr />
      </div>
    }
    @if ((skuNotFound || unknownSku) && !foundSku) {
      <div class="form-group m-b-20">
        <label for="productName" class="control-label">
          {{ "products.register.missing_fender_serial.product_name" | translate }}
          <span class="text-danger">*</span>
        </label>
        <input type="text" id="productName" [placeholder]="'products.register.missing_fender_serial.product_name_placeholder' | translate" class="form-control" [(ngModel)]="productName" required />
        <small class="text-muted">{{ "products.register.missing_fender_serial.product_name_help" | translate }}</small>
      </div>
      <div class="form-group m-b-20">
        <label for="shopLink" class="control-label">
          {{ "products.register.missing_fender_serial.shop_link" | translate }}
          <small class="text-muted">{{ "products.register.missing_fender_serial.optional" | translate }}</small>
        </label>
        <input type="text" id="shopLink" class="form-control" [(ngModel)]="shopLink" />
        <small class="text-muted">{{ "products.register.missing_fender_serial.shop_link_help" | translate }}</small>
      </div>
      <div class="form-group m-b-20">
        <label for="category" class="control-label">{{ "products.register.missing_fender_serial.category" | translate }}</label>
        <select name="category" id="category" class="form-control" [(ngModel)]="category">
          <option value="electric_guitars">{{ "products.register.missing_fender_serial.electric_guitars" | translate }}</option>
          <option value="acoustic_guitars">{{ "products.register.missing_fender_serial.acoustic_guitars" | translate }}</option>
          <option value="bass_guitars">{{ "products.register.missing_fender_serial.bass_guitars" | translate }}</option>
          <option value="amplifiers">{{ "products.register.missing_fender_serial.amplifiers" | translate }}</option>
          <option value="other">{{ "products.register.missing_fender_serial.other" | translate }}</option>
        </select>
      </div>
      <div class="form-group m-b-20">
        <label class="control-label">
          {{ "products.register.missing_fender_serial.upload_serial_photo" | translate }}
          <span class="text-danger">*</span>
        </label>
        @if (!serialImageUploader || !serialImageUploader.queue.length) {
          <div ng2FileDrop class="content-bg content-drop-zone m-b-20" [class.hovering]="hoveringFileDrops.serial" (fileOver)="fileOverBase($event, 'serial')" [uploader]="serialImageUploader">
            <div>
              <input type="file" aria-label="Upload File" ng2FileSelect [uploader]="serialImageUploader" />
              <br />
              <br />
              {{ "products.register.missing_fender_serial.drop_serial_photo" | translate }}
            </div>
          </div>
        }
        @if (displaySerialImage) {
          <div class="m-t-10">
            <img [src]="displaySerialImage" class="img-thumbnail" style="max-width: 200px; max-height: 200px" />
            @if (!fileUploadProgress.serialImage && !submitArgs.serialImageUrl) {
              <button class="btn btn-sm btn-danger" (click)="removeImage('serialImage')">
                {{ "products.register.missing_fender_serial.remove" | translate }}
              </button>
            }
            @if (fileUploadProgress.serialImage) {
              <div class="d-flex m-x-10 align-items-center">
                <fa-icon icon="spinner" [animation]="'spin'" class="m-r-5"></fa-icon>
                <strong>{{ fileUploadProgress.serialImage }}%</strong>
              </div>
            }
          </div>
        }
      </div>
      <div class="form-group m-b-20">
        <label class="control-label">
          {{ "products.register.missing_fender_serial.upload_gear_photo" | translate }}
          <span class="text-danger">*</span>
        </label>
        @if (!bodyImageUploader || !bodyImageUploader.queue.length) {
          <div ng2FileDrop class="content-bg content-drop-zone m-b-20" [class.hovering]="hoveringFileDrops.body" (fileOver)="fileOverBase($event, 'body')" [uploader]="bodyImageUploader">
            <div>
              <input type="file" aria-label="Upload File" ng2FileSelect [uploader]="bodyImageUploader" />
              <br />
              <br />
              {{ "products.register.missing_fender_serial.drop_gear_photo" | translate }}
            </div>
          </div>
        }
        @if (displayBodyImage) {
          <div class="m-t-10">
            <img [src]="displayBodyImage" class="img-thumbnail" style="max-width: 200px; max-height: 200px" />
            @if (!fileUploadProgress.bodyImage && !submitArgs.bodyImageUrl) {
              <button class="btn btn-sm btn-danger" (click)="removeImage('bodyImage')">
                {{ "products.register.missing_fender_serial.remove" | translate }}
              </button>
            }
            @if (fileUploadProgress.bodyImage) {
              <div class="d-flex m-x-10 align-items-center">
                <fa-icon icon="spinner" [animation]="'spin'" class="m-r-5"></fa-icon>
                <strong>{{ fileUploadProgress.bodyImage }}%</strong>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
@if (!foundSku && !savingComplete) {
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="saving" (click)="submit()">
      @if (!saving) {
        <span>{{ "general.submit" | translate }}</span>
      }
      @if (saving) {
        <span>
          <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
          {{ "general.saving_dots" | translate }}
        </span>
      }
    </button>
    <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
  </div>
}
